import { c as _c } from "react/compiler-runtime";
import { maybeMap } from '@funkey/shared';
import { cx } from 'class-variance-authority';
import { motion } from 'motion/react';
const ModalBackground: React.FC<{
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}> = props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.onClick) {
    t0 = maybeMap(props.onClick, _temp);
    $[0] = props.onClick;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.onClick ? "cursor-pointer" : "pointer-events-none";
  let t2;
  if ($[2] !== props.className || $[3] !== t1) {
    t2 = cx("fixed top-0 h-full w-full bg-blue/80 backdrop-blur-md", t1, props.className);
    $[2] = props.className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 1
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t0 || $[9] !== t2) {
    t6 = <motion.div onClick={t0} className={t2} initial={t3} exit={t4} animate={t5} />;
    $[8] = t0;
    $[9] = t2;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default ModalBackground;
function _temp(onClick) {
  return e => {
    e.stopPropagation();
    onClick(e);
  };
}